module.exports = __webpack_public_path__ + "assets/svg/Icons/32/date-gray-d31f11.svg";